import { Action } from '@ngrx/store';
import { Resource } from './resource.reducer';

export const LOAD           = '[Resource] Load';
export const LOAD_SUCCESS   = '[Resource] Load Success';
export const LOAD_ERROR     = '[Resource] Load Error';
export const CREATE         = '[Resource] Create';
export const CREATE_SUCCESS = '[Resource] Create Success';
export const UPDATE         = '[Resource] Update';
export const DELETE         = '[Resource] Delete';

export class Load implements Action {
    readonly type = LOAD;

    constructor() {
    }
}

export class LoadSuccess implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public resources: Resource[]) {
    }
}

export class LoadError implements Action {
    readonly type = LOAD_ERROR;

    constructor(error: any) {
        console.log('LOAD ERROR', error);
    }
}

export class Create implements Action {
    readonly type = CREATE;

    constructor(public resource: Resource) {
    }
}

export class CreateSuccess implements Action {
    readonly type = CREATE_SUCCESS;

    constructor(public resource: Resource) {
    }
}

export class Update implements Action {
    readonly type = UPDATE;

    constructor(public id: string, public changes: Partial<Resource>) {
    }
}

export class Delete implements Action {
    readonly type = DELETE;

    constructor(public id: string) {
    }
}

export type ResourceActions = Load | LoadSuccess | LoadError | Create | CreateSuccess | Update | Delete;


// WEBPACK FOOTER //
// ./libs/chassis-resource/src/+state/resource.actions.ts